import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Login from "@/views/Login.vue";
import Top from "@/views/Top.vue";
import SelectTemplate from "@/views/SelectTemplate.vue";
import SearchTemplate from "@/views/SearchTemplate.vue";
import EditTemplate from "@/views/EditTemplate.vue";
import SelectEditData from "@/views/SelectEditData.vue";
import SelectSampleData from "@/views/SelectSampleData.vue";
import AdminLogin from "@/views/AdminLogin.vue";
import AdminContract from "@/views/AdminContract.vue";
import AdminContractCreate from "@/views/AdminContractCreate.vue";
import AdminMaintenance from "@/views/AdminMaintenance.vue";
import AdminUsers from "@/views/AdminUsers.vue";
import AdminContractUsers from "@/views/AdminContractUsers.vue";
import AdminContractUserCreate from "@/views/AdminContractUserCreate.vue";

export const routeNames = {
  Login: "Login",
  Top: "Top",
  SelectTemplate: "SelectTemplate",
  SearchTemplate: "SearchTemplate",
  SearchTemplate2: "SearchTemplate2", // HACKME テンプレ検索画面で「この作者をもっと見る」押すとNavigationErrorが出る。明日入庫とのことなので暫定対処
  EditTemplate: "EditTemplate",
  SelectEditData: "SelectEditData",
  SelectSampleData: "SelectSampleData",
  AdminLogin: "AdminLogin",
  AdminContract: "AdminContract",
  AdminContractCreate: "AdminContractCreate",
  AdminMaintenance: "AdminMaintenance",
  AdminUsers: "AdminUsers",
  AdminContractUsers: "AdminContractUsers",
  AdminContractUserCreate: "AdminContractUserCreate",
};
export const isAdminView = (routeName: string) =>
  [
    routeNames.AdminLogin,
    routeNames.AdminContract,
    routeNames.AdminContractCreate,
    routeNames.AdminContractUsers,
    routeNames.AdminContractUserCreate,
    routeNames.AdminMaintenance,
    routeNames.AdminUsers,
  ].includes(routeName);

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: routeNames.Login,
    component: Login,
  },
  {
    path: "/top",
    name: routeNames.Top,
    component: Top,
  },
  {
    path: "/template/",
    name: routeNames.SelectTemplate,
    component: SelectTemplate,
  },
  {
    path: "/template/search/:campaignID?",
    name: routeNames.SearchTemplate,
    component: SearchTemplate,
  },
  {
    path: "/template/search",
    name: routeNames.SearchTemplate2,
    component: SearchTemplate,
  },
  {
    path: "/template/edit/:templateID",
    name: routeNames.EditTemplate,
    component: EditTemplate,
  },
  {
    path: "/edit",
    name: routeNames.SelectEditData,
    component: SelectEditData,
  },
  {
    path: "/sample",
    name: routeNames.SelectSampleData,
    component: SelectSampleData,
  },
  {
    path: "/admin",
    name: routeNames.AdminLogin,
    component: AdminLogin,
  },
  {
    path: "/admin/contract",
    name: routeNames.AdminContract,
    component: AdminContract,
  },
  {
    path: "/admin/contract/create",
    name: routeNames.AdminContractCreate,
    component: AdminContractCreate,
  },
  {
    path: "/admin/contract/:id/users",
    name: routeNames.AdminContractUsers,
    component: AdminContractUsers,
  },
  {
    path: "/admin/contract/:id/users/create",
    name: routeNames.AdminContractUserCreate,
    component: AdminContractUserCreate,
  },
  {
    path: "/admin/maintenance",
    name: routeNames.AdminMaintenance,
    component: AdminMaintenance,
  },
  {
    path: "/admin/users",
    name: routeNames.AdminUsers,
    component: AdminUsers,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior () {
    return { top: 0 };
  },
});

// ルートパス取得
export const findRoutePath = (routeName: string) =>
  router
    .getRoutes()
    .filter((x) => x.name == routeName)
    .map((x) => x.path)
    .find(() => true) ?? "/";

export default router;
